<template>
  <!-- 核心内容区：新闻图文（居中布局，优化阅读宽度） -->
  <main class="py-24 px-8 lg:px-16 xl:px-32 2xl:px-48" style="min-height: 90vh;">
    <div class="max-w-4xl mx-auto">
      <!-- 新闻标题与基础信息（发布时间、分类、作者） -->
      <div class="mb-8 text-reveal">
        <!-- 面包栏 -->
        <div class="text-sm text-reveal mb-3">
          <a :href="'/index' + langType" class="hover:text-primary transition-colors">{{ $t('header-home') }}</a>
          <span class="mx-2"><i class="fa fa-angle-right"></i></span>
          <a :href="'/index/news' + langType" class="hover:text-primary transition-colors">{{ $t('new-title') }}</a>
          <span class="mx-2"><i class="fa fa-angle-right"></i></span>
          <span class="text-gray-400">{{ $t('new-info-main') }}</span>
        </div>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="article-meta inline-flex items-center gap-1">
            <i class="fa fa-calendar-o text-xs" /> {{ new_info.rt }}
          </span>
        </div>
        <h1 class="text-2xl md:text-4xl font-bold mb-4 leading-tight text-dark">
          {{ new_info.n }}
        </h1>
      </div>

      <!-- 文章正文（分段清晰，含小标题、列表、引用、插图） -->
      <article class="text-reveal">
        <div class="article-content" v-html="new_info.t" />
      </article>
    </div>
  </main>
</template>

<script>
import { get_news_data_page } from '@/api/news'

export default {
  name: 'NewInfo',
  data: function() {
    return {
      new_info: {},
      config: {}
    }
  },
  computed: {
    langType() {
      return this.$i18n.locale === 'en' ? '' : '?lang=' + this.$i18n.locale
    }
  },
  created() {
    this.getNewsInfo()
  },
  methods: {
    getNewsInfo() {
      const new_id = this.$route.query.id
      get_news_data_page({ id: new_id }).then(d => {
        const data = d.d
        if (data) {
          this.new_info = data[0]
          /* HH:mm:ss*/
          this.new_info.rt = this.$moment(new Date(this.new_info.rt)).format('YYYY-MM-DD')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 新闻内容段落 */
.article-content {
  p {
    margin-bottom: 1.5rem;
    line-height: 1.8;
    color: #1E293B;
  }
  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 2.5rem 0 1rem;
    color: #1E293B;
  }
}
</style>
